var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65113 8.14772H8.12447L7.9378 7.96772C8.7378 7.03438 9.15113 5.76105 8.92447 4.40772C8.61113 2.55438 7.06447 1.07438 5.1978 0.847715C2.3778 0.501049 0.00446653 2.87438 0.351133 5.69438C0.5778 7.56105 2.0578 9.10772 3.91113 9.42105C5.26447 9.64772 6.5378 9.23438 7.47113 8.43438L7.65113 8.62105V9.14772L10.4845 11.981C10.7578 12.2544 11.2045 12.2544 11.4778 11.981C11.7511 11.7077 11.7511 11.261 11.4778 10.9877L8.65113 8.14772ZM4.65113 8.14772C2.99113 8.14772 1.65113 6.80772 1.65113 5.14772C1.65113 3.48772 2.99113 2.14772 4.65113 2.14772C6.31113 2.14772 7.65113 3.48772 7.65113 5.14772C7.65113 6.80772 6.31113 8.14772 4.65113 8.14772Z",
    fill: "white",
    fillOpacity: 0.73
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.009e0a6244c0b65be6dd4007b0bf8e8f.svg";
export { ForwardRef as ReactComponent };